// extracted by mini-css-extract-plugin
export default {"jackpot":"GamesJackpot__jackpot--x44","title":"GamesJackpot__title--27k","shine":"GamesJackpot__shine--2uq","sparkle":"GamesJackpot__sparkle--lch"};